<template>

  <data-form
    model="persons"
    :entity="person"
    :fields="fields"
    ignoreEntityChanges
    :after-submit="afterSubmit"
  />

</template>

<script>
export default {
  name: 'person-form',
  props: {
    person: {
      type: Object,
      required: true
    }
  },
  computed: {
    persons () {
      const persons = this.$store.getters['persons/data'](this.$store.dispatch)

      return persons.filter(({id}) => id !== this.person.id).map(({id, name}) => ({value: id, label: name}))
    },
    fields () {
      const fields = {
        'name': {
          type: 'text',
          rules: [{ required: true }, { max: 101 }]
        },
        'address': {
          type: 'text',
          rules: [{ max: 120 }]
        },
        'idcardnumber': {
          type: 'text',
          rules: [{ max: 120 }]
        },
        'workplace': {
          type: 'text',
          rules: [{ max: 80 }]
        },
        'supervisor': {
          type: 'select',
          rules: [{ max: 120 }],
          options: this.persons
        },
        'otheridentificator': {
          type: 'text',
          rules: [{ max: 120 }]
        },
        'picture': {
          type: 'file',
          multiple: false,
          preview: this.person.pictureURL
        }

      }

      return fields
    }
  },
  methods: {
    afterSubmit (formModel) {
      this.$router.back()
    }
  }
}
</script>



// WEBPACK FOOTER //
// PersonForm.vue?09c08b49